import { render, staticRenderFns } from "./AllocationTable.vue?vue&type=template&id=33905d84&"
import script from "./AllocationTable.vue?vue&type=script&lang=js&"
export * from "./AllocationTable.vue?vue&type=script&lang=js&"
import style0 from "./AllocationTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports